import React, { useState, useEffect } from 'react'
import { Box, Flex, Text, Group, Button, Pagination, Modal } from '@mantine/core'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import AuthLayout from '../../../../layout/AuthLayout'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { IconPlus } from '@tabler/icons-react' 
import { getCategorysList, deleteCategory } from '../../../../services/category'
import { useDebouncedCallback } from '@mantine/hooks'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import TableCustomMenuCategories from '../../../../component/pages/CustomMenuCategories/TableCustomMenuCategories'
import FormCustomMenuCategories from '../../../../component/pages/CustomMenuCategories/FormCustomMenuCategories'
import { modalDeleteData } from '../../../../component/ui/Prompt/modalDeleteData'

const defaultParameter = {
  'page[num]': 1,
  'page[limit]': 15,
  'filter[category_type][is]': 2,
  sort: '-id',
}

const labelTable = [
  {
    label: 'ID',
    width: 30
  },
  {
    label: 'Category Name',
    width: 350
  },
  {
    label: 'Image',
    width: 'auto'
  },
  {
    label: 'Priority',
    width: 'auto'
  },
  {
    label: 'Description',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 50
  },
]

const CustomMenuCategories = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [params, setParams] = useState(defaultParameter)
  const [menuCategoryList, setMenuCategoryList] = useState([])
  const [totalData, setTotalData] = useState(0)
  const [openModalForm, setOpenModalForm] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Promotions',
      route: null
    },
    {
      label: 'Menu Category Mobile',
      route: null
    },
  ]

  const handleGetMenuCategoryList = useDebouncedCallback(async () => {
    setLoading(true)
    try {
      const response = await getCategorysList(params)
      if (response.data.success) {
        const dataMenuCategory = response.data.data
        const countData = response.data.meta.pagination.total

        const remapData = dataMenuCategory.map((val) => {
          return val.attributes
        })

        setMenuCategoryList(remapData)
        setTotalData(countData)
      } else {
        setMenuCategoryList([])
        setTotalData(0)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }, 500)

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetMenuCategoryList()
    // eslint-disable-next-line
  }, [params])

  const actions = {
    edit: (val) => {
      setDetailData(val)
      setOpenModalForm(true)
    },
    delete: (val) => {
      modalDeleteData('Menu Category', val.id, val.name, deleteCategory, handleGetMenuCategoryList)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParams((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>Menu Category Mobile</Text>
            <Group gap='sm' align='center'>
              <Button size='xs' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalForm(true)}>Add New Category</Button>
            </Group>
          </Flex>
        </Box>
        <Box my={30}>
          {loading ? <LoadingData /> : menuCategoryList.length > 0 ? <TableCustomMenuCategories label={labelTable} data={menuCategoryList} actionMethod={handleAction} /> : <NoData />}
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} value={params['page[num]']} total={totalData > 0 ? Math.ceil(totalData / params['page[limit]']) : totalData} />
        </Flex>
        <Modal opened={openModalForm} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>{detailData === null ? 'Add' : 'Update'} Menu Category</Text>} withCloseButton={false}>
          <FormCustomMenuCategories dataCategory={detailData} onCloseForm={onCloseModalForm} reloadList={handleGetMenuCategoryList} />
        </Modal>
      </Box>
    </AuthLayout>
  )
}

export default CustomMenuCategories